import { type FunctionComponent } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import cx from 'classnames';
import { SearchContext } from '../types';
import { translate } from '../../../constants/translation';
import { ReactComponent as Globe } from '../../../assets/svg/Globe.svg';
import { ReactComponent as CloseIcon } from '../../../assets/svg/Close.svg';
import type React from 'react';

interface Props {
  operation: string;
  isWorldView: boolean;
  context: SearchContext;
  isMobileView: boolean;
  onOperationReset: (event: React.MouseEvent<SVGElement, MouseEvent>) => void;
  onOperationClick: () => void;
}

export const OperationBreadcrumb: FunctionComponent<Props> = ({
  operation,
  isWorldView,
  context,
  isMobileView,
  onOperationReset,
  onOperationClick,
}) => {
  const renderRightIcon = (): React.JSX.Element => {
    if (isWorldView) {
      return null;
    }

    if (context === SearchContext.Operation) {
      return <CloseIcon onClick={onOperationReset} />;
    }

    return <ChevronRightIcon color="gray.700" />;
  };

  const shouldHideText = isMobileView && context === SearchContext.Vessel;

  return (
    <Box className="breadcrumb" onClick={onOperationClick}>
      <div className="breadcrumb-icon">
        <Globe />
      </div>
      <Text className={cx('breadcrumb-text', { hidden: shouldHideText })}>
        {isWorldView ? translate('WORLD_VIEW') : operation}
      </Text>
      <div className="breadcrumb-icon">{renderRightIcon()}</div>
    </Box>
  );
};
